<template>
  <div
    :class="$style.modal"
    v-show="show"
    @mousedown.self="_clickOutside"
    :style="cssStyle"
    ref="modal"
    tabindex="-1"
    v-trap-focus
  >
    <slot></slot>
  </div>
</template>

<script>
import attachable from '@/mixins/attachable.js'
import TrapFocus from '@/directives/trap-focus.js'

export default {

  mixins: [
    attachable,
  ],

  directives: {
    TrapFocus,
  },

}
</script>

<style lang="scss" module>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba($color-black, .5);
  padding: var(--content-padding);
  overflow: auto;
  overscroll-behavior-y: contain;
}
</style>
